
export default {
  data() {
    return {
      displayCategory: false
    };
  },
  methods: {
    handleDisplayCategoryToggle() {
      this.$emit("display-category-toggled", this.displayCategory);
    }
  }
};
